import { apiClient } from '../../base/ApiClients'
import { IStatisticsCount } from '../../../models/statistics/IStatistics'

export const GetStatisticsCountQuery = async () => {
  return await apiClient.get<IStatisticsCount>("Statistics/count")
}